import { jsxs as F, jsx as i } from "react/jsx-runtime";
import { useState as o, useRef as V } from "react";
import { isEqual as k } from "es-toolkit/predicate";
import { noop as Oe, isEmpty as be } from "es-toolkit/compat";
import K from "../../utils/classNames.js";
import ve, { filterOptions as xe } from "./BaseSelectDropdown.js";
import we from "../../hooks/useClickOutside.js";
import De from "../../hooks/useEffectOnce.js";
import Me from "../../hooks/useMergeRefs.js";
import Ne from "./ClearButton.js";
import Ee from "./SelectFilter.js";
import Ae from "./SelectedOption.js";
import Te from "./WithFeedbackAndAddon.js";
const u = -1, ze = (R) => {
  const {
    name: O,
    id: B = O,
    label: _,
    options: t = [],
    value: n,
    onChange: b = Oe,
    placeholder: j,
    isLoading: L = !1,
    dropup: W = !1,
    pullRight: q = !1,
    autoDropDirection: z = !0,
    bsSize: g = "md",
    disabled: v = !1,
    tabIndex: X = 0,
    hasError: G = !1,
    useFilter: H = !1,
    useClear: J = !1,
    noItemMessage: Q,
    selectedOptionText: x,
    showSelectedItemIcon: Y = !1,
    showUnselectedItemIcons: Z = !1,
    dropdownClassName: $,
    btnClassName: w,
    className: D,
    inputAddon: M,
    errorMessage: N,
    warningMessage: E,
    messageWhiteSpace: ee = "normal",
    ...te
  } = R, [r, A] = o(!1), [h, p] = o(null), [I, c] = o(!1), [T, d] = o(""), [se, l] = o(t), [y, oe] = o([]), [ne, m] = o(u), [P, f] = o(!1), re = V(), U = V(null), le = we(() => S()), ae = Me(re, le), C = (e, s) => {
    s && !be(s) ? p(e.find((a) => a.id === s[0]) || null) : e && p(e.find((a) => a.selected) || null);
  };
  De(() => {
    C(t, n);
  });
  const [ie, ce] = o(t);
  k(t, ie) || (C(t, n), l(t), ce(t));
  const [de, fe] = o(n);
  k(n, de) || (C(t, n), fe(n));
  const ue = (e = []) => {
    !e.length || (I || T) && y.length > 0 || oe(e);
  }, pe = () => {
    p(null), c(!1), d(""), l(t), f(!1), m(u), b(void 0);
  }, me = () => {
    const e = K(
      "dropdown-toggle",
      "form-control",
      "text-left",
      w && w,
      g === "sm" && "input-sm",
      g === "lg" && "input-lg",
      v && "disabled"
    ), s = /* @__PURE__ */ F(
      "button",
      {
        type: "button",
        id: B,
        name: O,
        className: e,
        "data-toggle": "dropdown",
        tabIndex: X,
        "aria-haspopup": "true",
        "aria-expanded": r,
        onClick: Ce,
        ref: U,
        children: [
          H && r && /* @__PURE__ */ i(
            Ee,
            {
              isFilterActive: I,
              filterValue: T,
              onChange: he
            }
          ),
          x || /* @__PURE__ */ i(
            Ae,
            {
              label: _,
              placeholder: j,
              selectedItem: h,
              options: t,
              showSelectedItemIcon: Y,
              showUnselectedItemIcons: Z
            }
          ),
          /* @__PURE__ */ F("span", { className: "select-toggle-actions", children: [
            /* @__PURE__ */ i(Ne, { showClear: J, selectedItem: h, onClear: pe }),
            /* @__PURE__ */ i("span", { className: "caret" })
          ] })
        ]
      }
    );
    return !M && !N && !E ? s : /* @__PURE__ */ i(
      Te,
      {
        bsSize: g,
        inputAddon: M,
        errorMessage: N,
        warningMessage: E,
        messageWhiteSpace: ee,
        children: s
      }
    );
  }, ge = () => {
    let e = ne;
    return P && !h && (e = 0), /* @__PURE__ */ i(
      ve,
      {
        isOpen: r,
        isLoading: L,
        options: se,
        focusedItemIndex: e,
        keyboardUsed: P,
        updateDOMValues: ue,
        onSelect: Ie,
        onClose: S,
        noItemMessage: Q,
        pullRight: q,
        dropup: W,
        autoDropDirection: z,
        dropdownClassName: $
      }
    );
  }, he = (e) => {
    e.preventDefault();
    const s = e.currentTarget.value;
    if (s === "") {
      c(!1), d(""), l(t), f(!1), m(u);
      return;
    }
    const a = xe(y, s, t), Fe = a.length > 0 ? 0 : u;
    c(!0), d(s), l(a), f(!0), m(Fe);
  }, Ie = (e) => {
    p(e || null), c(!1), d(""), l(t), b(e), S();
  }, Ce = (e) => {
    if (v || I)
      return;
    const s = e.detail === 0;
    A(!r), f(s);
  }, S = () => {
    r && (A(!1), c(!1), d(""), l(t), f(!1), m(u), U.current?.focus());
  }, Se = K("select", "dropdown", r && "open", G && "has-error", D && D);
  return /* @__PURE__ */ F("div", { ...te, className: Se, ref: ae, children: [
    me(),
    ge()
  ] });
};
export {
  ze as default
};
//# sourceMappingURL=Select.js.map
